const bold = "_bold_6j9u9_10";
const italic = "_italic_6j9u9_14";
const underline = "_underline_6j9u9_18";
const strikethrough = "_strikethrough_6j9u9_34";
const underlineStrikethrough = "_underlineStrikethrough_6j9u9_38";
const subscript = "_subscript_6j9u9_42";
const superscript = "_superscript_6j9u9_47";
const code = "_code_6j9u9_52";
const quote = "_quote_6j9u9_59";
const nestedListItem = "_nestedListItem_6j9u9_66";
const listitem = "_listitem_6j9u9_76";
const listItemChecked = "_listItemChecked_6j9u9_80";
const listItemUnchecked = "_listItemUnchecked_6j9u9_81";
const admonitionDanger = "_admonitionDanger_6j9u9_158";
const admonitionInfo = "_admonitionInfo_6j9u9_159";
const admonitionNote = "_admonitionNote_6j9u9_160";
const admonitionTip = "_admonitionTip_6j9u9_161";
const admonitionCaution = "_admonitionCaution_6j9u9_162";
const mdxExpression = "_mdxExpression_6j9u9_195";
const lexicalThemeStyles = {
  bold,
  italic,
  underline,
  strikethrough,
  underlineStrikethrough,
  subscript,
  superscript,
  code,
  quote,
  nestedListItem,
  listitem,
  listItemChecked,
  listItemUnchecked,
  admonitionDanger,
  admonitionInfo,
  admonitionNote,
  admonitionTip,
  admonitionCaution,
  mdxExpression
};
export {
  admonitionCaution,
  admonitionDanger,
  admonitionInfo,
  admonitionNote,
  admonitionTip,
  bold,
  code,
  lexicalThemeStyles as default,
  italic,
  listItemChecked,
  listItemUnchecked,
  listitem,
  mdxExpression,
  nestedListItem,
  quote,
  strikethrough,
  subscript,
  superscript,
  underline,
  underlineStrikethrough
};
